<div
  class="button button_dark-outlined button_standard button_centered"
  (click)="onLoadMore()"
>
  Load more items
</div>
